export const setContactUsSettings = value => ({
    type: 'SET_CONTACT_US_SETTINGS',
    value
});
